import React from 'react';
import { FadeIn } from './FadeIn';
import { Gift, CheckCircle2 } from 'lucide-react';
import { motion } from 'framer-motion';
export function Bonuses() {
  const bonuses = [{
    num: '01',
    title: 'Pack de Checklists Imprimibles para Consulta y Seguimiento',
    desc: 'Primera consulta, seguimiento, adherencia, estancamiento y alertas frecuentes.'
  }, {
    num: '02',
    title: 'Planilla de Seguimiento del Paciente',
    desc: 'Peso, medidas, síntomas, energía, hábitos y progreso más allá de la balanza.'
  }, {
    num: '03',
    title: 'Guía de Organización del Consultorio',
    desc: 'Cómo ordenar tu agenda, tus tiempos y tu sistema de atención para no vivir trabajando.'
  }, {
    num: '04',
    title: 'Banco de Frases para Consulta',
    desc: 'Frases listas para usar en consulta, adherencia, motivación, límites y reencuadre.'
  }, {
    num: '05',
    title: 'Matriz Rápida de Adaptación de Planes',
    desc: 'Una herramienta práctica para ajustar planes, menús e indicaciones sin empezar de cero.'
  }, {
    num: '06',
    title: 'Guía Práctica para Destrabar Casos Frecuentes',
    desc: 'Qué revisar primero y cómo ajustar cuando el paciente no avanza, no cumple o se estanca.'
  }];
  return <section className="pt-4 pb-8 px-4 max-w-5xl mx-auto" data-id="element-17">
      <FadeIn className="text-center mb-6" data-id="element-18">
        <div className="inline-flex items-center justify-center w-14 h-14 rounded-full bg-mint text-white mb-3 shadow-sm" data-id="element-19">
          <Gift size={28} data-id="element-20" />
        </div>
        <h2 className="font-['Open_Sans',_sans-serif] font-[900] text-2xl md:text-4xl text-dark mb-2 leading-tight" data-id="element-21">
          Bonos especiales para que tengas{' '}
          <span className="text-mint" data-id="element-22">todo listo desde el día uno</span>
        </h2>
      </FadeIn>

      <div className="grid sm:grid-cols-2 gap-3 max-w-4xl mx-auto" data-id="element-23">
        {bonuses.map((bonus, idx) => <FadeIn key={idx} delay={idx * 0.07} data-id="element-24">
            <motion.div className="relative bg-surface border border-mint/15 rounded-2xl p-5 h-full flex flex-col group overflow-hidden shadow-lg shadow-black/40 hover:border-mint/40 transition-colors" whileHover={{
          y: -2,
          boxShadow: '0 10px 30px -10px rgba(74,222,128,0.15)'
        }} transition={{
          duration: 0.25,
          ease: 'easeOut'
        }} data-id="element-25">
              {/* Left accent line */}
              <div className="absolute left-0 top-4 bottom-4 w-[3px] rounded-full bg-gradient-to-b from-mint/80 via-mint/40 to-transparent" data-id="element-26" />

              {/* Number badge */}
              <div className="flex items-start gap-3.5 mb-3 pl-2" data-id="element-27">
                <div className="shrink-0 w-10 h-10 rounded-xl bg-gradient-to-br from-mint/20 to-mint/5 border border-mint/20 flex items-center justify-center shadow-sm group-hover:bg-mint/20 transition-colors" data-id="element-28">
                  <span className="text-lg" data-id="element-29">🎁</span>
                </div>
                <div className="flex-1 min-w-0" data-id="element-30">
                  <p className="text-mint/80 text-[10px] font-bold tracking-widest uppercase mb-0.5" data-id="element-31">
                    Bono {bonus.num}
                  </p>
                  <h3 className="font-['Open_Sans',_sans-serif] font-[800] text-[15px] text-dark leading-snug group-hover:text-mint transition-colors" data-id="element-32">
                    {bonus.title}
                  </h3>
                </div>
              </div>

              {/* Price */}
              <div className="flex items-center gap-2.5 mt-auto pt-3 border-t border-mint/10 pl-[3.875rem]" data-id="element-33">
                <span className="text-dark/40 line-through text-xs" data-id="element-34">
                  $9.000
                </span>
                <span className="inline-flex items-center gap-1.5 bg-mint/10 border border-mint/30 text-mint font-[800] text-xs font-['Open_Sans',_sans-serif] uppercase tracking-wide px-2.5 py-1 rounded-full" data-id="element-35">
                  <CheckCircle2 size={12} data-id="element-36" />
                  Gratis
                </span>
              </div>
            </motion.div>
          </FadeIn>)}
      </div>
    </section>;
}